<template>
  <AccountPanel title="Dane kontrahenta">
    <h5 class="card-title">{{user.backup.forname}} {{user.backup.surname}}  <{{user.backup.email}}> </h5>
    <p class="card-text">{{user.backup.street}}</p>
    <p class="card-text">{{user.backup.postcode}} {{user.backup.city}}</p>
    <p class="card-text">tel: {{user.backup.phone}}</p>
  </AccountPanel>
</template>

<script>

  import { mapState } from 'vuex';
  import AccountPanel from './AccountPanel.vue'

  export default {
    props: ['id'],
    components: {AccountPanel},
    computed: {
      ...mapState({
        user: state => state.user.authorizedUser
      }),
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/UserData.vue